<template>
	<div class="wrap" :style="{ backgroundColor: bgColor, color: color, backgroundImage: setBgImg }">
		<div v-for="data in datas" :key="data.id">
			<!-- 切图 -->
			<section-img v-if="data.img" :dataP="data" :filenameP="filename" :imgpathP="imgpath" />
			<!-- swiper -->
			<section-swiper v-else-if="data.swiper" :dataP="data" :filenameP="filename" :imgpathP="imgpath" :swiperPathP="swiperPath" />
			<!-- tel -->
			<section-tel v-else-if="data.tel" :dataP="data" />
			<!-- form -->
			<section-form v-else-if="data.form" :dataP="data" :dataSourceP="dataSource" />
		</div>
		<bottom />
	</div>
</template>

<script>
import SectionImg from '@/components/SectionImg';
import SectionSwiper from '@/components/SectionSwiper';
import SectionTel from '@/components/SectionTel';
import SectionForm from '@/components/SectionForm';
import Bottom from '@/components/Bottom';
export default {
	components: {
		SectionImg,
		SectionSwiper,
		SectionTel,
		SectionForm,
		Bottom
	},
	data() {
		return {
			filename: this.$route.params.poster,
			pathname: this.$route.meta.pathname,
			swiperPath: '',
			imgpath: '',
			datas: '',
			bgColor: '',
			color: '',
			bgImg: '',
			dataSource: ''
		};
	},
	created() {
		document.title = this.$route.meta.title;
		//console.log(this.pathname, this.filename)
		import(`@/poster/${this.pathname}/${this.filename}`)
			.then((res) => {
				this.datas = res.default.posters;
				this.bgColor = res.default.bgColor;
				this.color = res.default.color;
				this.dataSource = res.default.dataSource || '官网';
				this.imgpath = `assets/images/${this.pathname}`;
				this.swiperPath = res.default.swiperPath || 'poster_1';
				this.bgImg = res.default.bgImg || false;
			})
			.catch(() => {
				this.$router.push('/404');
			});
	},
	computed: {
		setBgImg() {
			if (this.bgImg) {
				return `url('${require(`@/${this.imgpath}/${this.filename}/${this.bgImg}`)}')`;
			}else{
				return 'none'
			}
		}
	}
};
</script>
